// extracted by mini-css-extract-plugin
export default {"wrapper":"DashBoard_wrapper__I2hdD","title":"DashBoard_title__ThRvJ","item":"DashBoard_item__vKO3t","mantine-Tooltip-tooltip":"DashBoard_mantine-Tooltip-tooltip__pn+MZ"};